import type { DomainCertificate } from '@/api/types';
import { quoteNpcArg } from '@/lib/spatial-route';

const HORIZON_MS = 14 * 24 * 60 * 60 * 1000;

export function rebindCommand(cert: DomainCertificate): string | null {
  if (!cert.primaryDomain || !cert.serverId || !cert.certPath || !cert.keyPath) return null;
  return [
    'npc cert rebind',
    quoteNpcArg(cert.primaryDomain),
    '--server',
    quoteNpcArg(cert.serverId),
    '--cert-path',
    quoteNpcArg(cert.certPath),
    '--key-path',
    quoteNpcArg(cert.keyPath),
  ].join(' ');
}

export function needsRebind(cert: DomainCertificate): boolean {
  if (!rebindCommand(cert)) return false;
  if (!cert.expiresAt) return cert.status === 'expiring' || cert.status === 'expired';
  return new Date(cert.expiresAt).getTime() - Date.now() <= HORIZON_MS;
}
